import { style } from '@vanilla-extract/css';

export const daysLimitInput = style(
  {
    width: '40px',
  },
  'days-limit-input',
);
